/**
 * A locale's own name (integration plan slice 5): `ui.lang.<locale>`, the same
 * in every table, so each language reads in its own script wherever it is
 * offered (since slice 6b, the pause menu's language row).
 */
import type { Locale } from '@ab/session';

/** The label key of a locale: `ui.lang.en`, `ui.lang.zh_hans`, `ui.lang.ja` (keys are lower case with underscores). */
export const languageKey = (locale: Locale): string => `ui.lang.${locale.toLowerCase().replace('-', '_')}`;
